import { SectionKind, type SectionType } from "components/server-types";

const getSectionKind = (sectionOrSectionKind: SectionType | SectionKind | null | undefined) => {
  if (!sectionOrSectionKind) {
    return undefined;
  }

  return typeof sectionOrSectionKind === "string"
    ? sectionOrSectionKind
    : sectionOrSectionKind.kind;
};

export const isLinkedSection = (
  sectionOrSectionKind: SectionType | SectionKind | null | undefined,
) => {
  return getSectionKind(sectionOrSectionKind) === SectionKind.LINKED;
};

export const isTemplateSection = (
  sectionOrSectionKind: SectionType | SectionKind | null | undefined,
) => {
  return getSectionKind(sectionOrSectionKind) === SectionKind.TEMPLATE;
};

export const isUnlinkedSection = (
  sectionOrSectionKind: SectionType | SectionKind | null | undefined,
) => {
  return getSectionKind(sectionOrSectionKind) === SectionKind.UNLINKED;
};
